import { SxProps, Typography } from '@mui/material'
import { Trans } from 'react-i18next'

interface IProps {
  sx?: SxProps
  number: number
}

export function ProjectTitle({ sx, number }: IProps) {
  return (
    <Typography color="primary" variant="subtitle20" sx={sx}>
      <Trans
        ns="widgets"
        i18nKey="main-page.projects.project-title"
        values={{ number }}
      />
    </Typography>
  )
}
